import React from "react";
import { formatPercent } from "app/formatting/functions";

import "./style.scss";

export interface PerformanceLabelProps {
    /** Value between 0 and 1 representing a percentage */
    value?: number | null;
    /** Applies a style modifier to render the component with a bigger font size */
    isBig?: boolean;
    /** If set, the colored background will become transparent */
    noBackground?: boolean;
}

/**
 * Renders a colored label displaying a percentage value
 */
export const PerformanceLabel = ({ value, isBig, noBackground }: PerformanceLabelProps) => {
    const classNames = ["performanceLabel"];
    if (value === undefined) {
        value = null;
    }

    if (value !== null && value >= 0) {
        classNames.push("positive");
    }

    if (value === null || value === undefined) {
        classNames.push("neutral");
    }

    if (isBig) {
        classNames.push("large");
    }

    if (noBackground) {
        classNames.push("noBG");
    }

    return (
        <span className={classNames.join(" ")} title={value === null ? "Nicht abrufbar" : undefined}>
            {value === null || value === undefined ? "-" : `${value >= 0 ? "+" : ""}${formatPercent(value)}`}
        </span>
    );
};
